import { formatDate1, formatTime1, convertToDateOnly, convertToDateMonth, formatDate2 } from "../../app/utils/helpers"

const ScheduleDetail = ({ imgPath, detail1, detail2, conj, isDate = false, isRange = false, isFullDate = false }) => {
  return (
    <div className="flex items-center">
      <img width="100" src={imgPath} className="w-4 sm:w-5 md:w-6 mr-1 sm:mr-2" />
      {isFullDate ?
        <span className="text-[16px] sm:text-[24px] xl:text-[26px] font-agcasmlt text-[#6e6060] mt-0.5 md:mt-1 relative -bottom-0.5 font-light">
          {formatDate2(detail1)}
        </span> :
        <span className="text-[16px] sm:text-[24px] xl:text-[26px] font-agcasmlt text-[#6e6060] mt-0.5 md:mt-1 relative -bottom-0.5 font-light">{
          isDate ?
            isRange ?
              convertToDateOnly(detail1) :
              Array.isArray(detail1) ?
                detail1.map((d, i) => (
                  i < detail1.length - 1 && <span key={i}>{convertToDateMonth(d)}
                    {i < detail1.length - 2 && ", "}
                  </span>
                )) :
                convertToDateMonth(detail1) :
            !detail2 ? `${formatTime1(detail1)} WITA` : formatTime1(detail1)
        }{conj}{(isDate && detail2) ?
          formatDate1(detail2) : detail2 ?
            `${formatTime1(detail2)} WITA` : ""}
        </span>
      }
    </div>
  )
}

export default ScheduleDetail